export default "__VITE_ASSET__ccf2cfbe__"